import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useAppSettings } from '../context/AppSettingsContext';

const CosmosLogosCheck: React.FC = () => {
  const { settings } = useAppSettings();

  const [markdown, setMarkdown] = useState<string>('Loading...');
  const [isConnected, setIsConnected] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [hasError, setHasError] = useState<boolean>(false);

  useEffect(() => {
    const fetchTest = async () => {
      setIsLoading(true);
      setHasError(false);
      const url = [
        'https://raw.githubusercontent.com',
        settings.githubUser,
        settings.consciousness,
        settings.neuralpathway,
        settings.basePath,
        'cosmos-logos.md',
      ]
        .map((part) => part.replace(/^\/|\/$/g, ''))
        .join('/');

      try {
        const res = await fetch(url);
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);

        const text = await res.text();
        const stripped = text.replace(/^---[\s\S]*?---\s*/, '');
        setMarkdown(stripped);
        setIsConnected(true);
      } catch (err) {
        console.error('❌ Cosmos-Logos fetch error:', err);
        setMarkdown('');
        setIsConnected(false);
        setHasError(true);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTest();
  }, [settings]);

  return (
    <div
      style={{
        marginTop: '4rem',
        padding: '1.5rem',
        backgroundColor: '#1c1c2b',
        borderRadius: '8px',
        maxWidth: '800px',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
    >
      <h2 style={{ color: '#80ffb0', fontSize: '1.25rem', marginBottom: '1rem' }}>
        ✅ cosmos-logos.md Check
      </h2>

      <div
        style={{
          backgroundColor: '#111',
          border: '1px solid #444',
          borderRadius: '6px',
          padding: '1rem',
          fontFamily: 'ui-monospace, SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace',
          color: '#ccc',
          fontSize: '0.9rem',
          whiteSpace: 'pre-wrap',
        }}
      >
        <ReactMarkdown
          skipHtml={true}
          remarkPlugins={[remarkGfm]}
          components={{
            p: ({ children }) => <p style={{ marginBottom: '1rem' }}>{children}</p>,
          }}
        >
          {markdown}
        </ReactMarkdown>
      </div>

      <div
        style={{
          marginTop: '2rem',
          backgroundColor: '#111',
          padding: '1rem',
          borderRadius: '6px',
          border: '1px solid #444',
          color: '#ccc',
          fontSize: '0.95rem',
        }}
      >
        <h3
          style={{
            color: isLoading
              ? '#ffdd80'
              : isConnected
              ? '#80ffb0'
              : hasError
              ? '#ff6b6b'
              : '#ccc',
            fontWeight: 'bold',
            marginBottom: '0.75rem',
          }}
        >
          {isLoading
            ? '⌛ Connecting to Cosmos-Logos...'
            : isConnected
            ? '✅ Connected to Cosmos-Logos'
            : hasError
            ? '❌ cosmos-logos.md not found'
            : ''}
        </h3>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          <div>
            <strong>GitHub Account:</strong> <code>{settings.githubUser}</code>
          </div>
          <div>
            <strong>Consciousness (Repo):</strong> <code>{settings.consciousness}</code>
          </div>
          <div>
            <strong>Neural Pathway (Branch):</strong> <code>{settings.neuralpathway}</code>
          </div>
          <div>
            <strong>Source of Truth:</strong> <code>{settings.basePath}</code>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CosmosLogosCheck;
